import { Heart } from "lucide-react";

export const FreeForLifeBanner = () => (
  <div className="mt-6 rounded-3xl border-2 border-[#10B981] bg-white/70 backdrop-blur-lg shadow-lg p-6" data-testid="free-for-life-banner">
    <p className="text-xl md:text-2xl font-bold text-[#10B981] leading-snug flex items-start gap-3">
      <Heart className="w-7 h-7 fill-[#FF1A82] text-[#FF1A82] shrink-0 mt-1" />
      <span>
        Every member that signs up during the free period, will be free for life, as long as they are an active user.
        Inactivity will be deleted during this time. This offer won't last long.
        I welcome you into the Welp community with open arms!
      </span>
    </p>
    <p className="mt-3 text-lg text-[#5A5A5A] font-semibold pl-10" data-testid="free-period-fine-print">
      Inactivity for 18 days will result in profile deletion during the free period.
    </p>
  </div>
);
